import { API_URL } from "../api";

const PRODUCTION_STORAGE_ORIGIN = "https://app.visaro.ng";

export const normalizeStorageUrl = (url?: string | null) => {
  if (!url) return "";

  try {
    const apiOrigin = new URL(API_URL).origin;
    const assetUrl = new URL(url, apiOrigin);

    if (assetUrl.pathname.startsWith("/storage/")) {
      return `${PRODUCTION_STORAGE_ORIGIN}${assetUrl.pathname}${assetUrl.search}`;
    }

    return assetUrl.toString();
  } catch {
    return url;
  }
};
